<zip-co-header></zip-co-header>

<div *ngIf="page$ | async">
  <app-contentful-renderer [model]="page$ | async"></app-contentful-renderer>

  <section class="usp-container"></section>

  <!-- Gift card heading -->
  <div class="content-max-width">
    <h1>Gift cards</h1>
    <div *ngIf="showMaintenanceMessage" class="gc-maintenance-message">
      <p>
        This site is undergoing maintenance. Some gift cards may be unavailable during this time.
      </p>
    </div>
  </div>

  <!-- Search Bar -->
  <div class="search" *ngIf="featuredGiftCards.length">
    <div class="content-max-width">
      <div class="search-bar-wrapper">
        <i class="zip-icon-search-rebrand"></i>
        <input
          [id]="zipYiElement.GiftCardSearchInput"
          type="text"
          placeholder="Search gift cards"
          (input)="search()"
          [(ngModel)]="giftcardCategoryV2Service.searchGiftCardsInput"
        />
      </div>
    </div>
  </div>

  <app-gift-card-category-v2></app-gift-card-category-v2>

  <!-- Backend Category Filter -->
  <app-gift-card-list
    *ngIf="
    giftcardCategoryV2Service.selectedCategoryId !== staticCategory.ZipMoneyDeals &&
      giftcardCategoryV2Service.selectedCategoryId !== staticCategory.OtherDeals &&
      giftcardCategoryV2Service.selectedCategoryId !== staticCategory.All &&
      giftcardCategoryV2Service.searchGiftCardsInput === ''
    "
  >
    <div *ngIf="giftcardCategoryV2Service.isLoadingGiftcardCategory; else loadingDone">
      <app-spinner></app-spinner>
    </div>
    <ng-template #loadingDone>
      <div
        class="no-result-category"
        *ngIf="giftcardCategoryV2Service.giftcardCategoriesFiltering.length === 0"
      >
        Sorry, we can’t find the card you are looking for. Try searching for a different one?
      </div>
      <div class="category-card-listing">
        <app-gift-card
          *ngFor="let card of giftcardCategoryV2Service.giftcardCategoriesFiltering"
          [href]="card.cardTypeStatus !== 'AVAILABLE' ? [] : ['/checkout', card.id]"
          [image]="card.image"
          [brand]="card.brand"
          [cardAvailable]="card.cardTypeStatus === 'AVAILABLE'"
          [tags]="card.tags"
        >
        </app-gift-card>
      </div>
    </ng-template>
  </app-gift-card-list>

  <!-- Zip Money Deals Filter -->
  <app-gift-card-list
    *ngIf="
      giftcardCategoryV2Service.selectedCategoryId === staticCategory.ZipMoneyDeals &&
      giftcardCategoryV2Service.searchGiftCardsInput === '' &&
      zipMoneyCashbackGiftCards.length > 0
    "
  >
    <div class="category-card-listing">
      <app-gift-card
        *ngFor="let card of zipMoneyCashbackGiftCards"
        [href]="card.cardTypeStatus !== 'AVAILABLE' ? [] : ['/checkout', card.id]"
        [image]="card.image"
        [brand]="card.brand"
        [cardAvailable]="card.cardTypeStatus === 'AVAILABLE'"
        [tags]="card.tags"
      >
      </app-gift-card>
    </div>
  </app-gift-card-list>

  <!-- Other Deals Filter -->
  <app-gift-card-list
    *ngIf="
      giftcardCategoryV2Service.selectedCategoryId === staticCategory.OtherDeals &&
      giftcardCategoryV2Service.searchGiftCardsInput === '' &&
      otherPromoGiftCards.length > 0
    "
  >
    <div class="category-card-listing">
      <app-gift-card
        *ngFor="let card of otherPromoGiftCards"
        [href]="card.cardTypeStatus !== 'AVAILABLE' ? [] : ['/checkout', card.id]"
        [image]="card.image"
        [brand]="card.brand"
        [cardAvailable]="card.cardTypeStatus === 'AVAILABLE'"
        [tags]="card.tags"
      >
      </app-gift-card>
    </div>
  </app-gift-card-list>

  <!-- Search Gift Cards -->
  <ng-container
    *ngIf="
      searchedGiftCards &&
      searchedGiftCards.length >= 0 &&
      giftcardCategoryV2Service.searchGiftCardsInput !== ''
    "
  >
    <div class="content-max-width">
      <h2>Search results</h2>
    </div>

    <app-gift-card-list>
      <div class="no-result" *ngIf="searchedGiftCards.length === 0">
        Sorry, we can’t find the card you are looking for. Try searching for a different one?
      </div>
      <app-gift-card
        *ngFor="let card of searchedGiftCards"
        [href]="card.cardTypeStatus !== 'AVAILABLE' ? [] : ['/checkout', card.id]"
        [image]="card.image"
        [brand]="card.brand"
        [cardAvailable]="card.cardTypeStatus === 'AVAILABLE'"
        [tags]="card.tags"
      >
      </app-gift-card>
    </app-gift-card-list>
  </ng-container>

  <!-- Zip Money cashback Gift Cards Section -->
  <section
    *ngIf="
      zipMoneyCashbackGiftCards.length > 0 &&
      giftcardCategoryV2Service.selectedCategoryId !== staticCategory.ZipMoneyDeals
    "
  >
    <div class="content-max-width">
      <h2>
        Zip Money cashback
        <span
          *ngIf="zipMoneyCashbackGiftCards.length > 4"
          class="view-all-button"
          (click)="viewAllZipMoneyDeals()"
          >View all</span
        >
      </h2>
    </div>

    <app-gift-card-list>
      <app-gift-card
        *ngFor="let card of zipMoneyCashbackGiftCards.slice(0, 4)"
        [href]="card.cardTypeStatus !== 'AVAILABLE' ? [] : ['/checkout', card.id]"
        [image]="card.image"
        [brand]="card.brand"
        [cardAvailable]="card.cardTypeStatus === 'AVAILABLE'"
        [tags]="card.tags"
      >
      </app-gift-card>
    </app-gift-card-list>
  </section>

  <!-- Featured Gift Cards -->
  <section>
    <div class="content-max-width">
      <h2>Featured</h2>
    </div>

    <app-gift-card-list>
      <app-gift-card
        *ngFor="let card of featuredGiftCards"
        [href]="card.cardTypeStatus !== 'AVAILABLE' ? [] : ['/checkout', card.id]"
        [image]="card.image"
        [brand]="card.brand"
        [cardAvailable]="card.cardTypeStatus === 'AVAILABLE'"
        [tags]="card.tags"
        [priorityImage]="true"
      >
      </app-gift-card>
    </app-gift-card-list>
  </section>

  <!-- All Gift Cards -->
  <section *ngIf="giftcardCategoryV2Service.selectedCategoryId === staticCategory.All">
    <div class="content-max-width">
      <h2>All gift cards</h2>
    </div>

    <app-gift-card-list>
      <app-gift-card
        *ngFor="let card of giftCards"
        [href]="card.cardTypeStatus !== 'AVAILABLE' ? [] : ['/checkout', card.id]"
        [image]="card.image"
        [brand]="card.brand"
        [cardAvailable]="card.cardTypeStatus === 'AVAILABLE'"
        [tags]="card.tags"
        [attr.data-testid]="'all_gc_' + card.id"
      >
      </app-gift-card>
    </app-gift-card-list>
  </section>
</div>

<app-footer></app-footer>
